var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Prop, Component, Watch, Mixins } from "vue-property-decorator";
import HeaderControl from '@/common/components/HeaderControl.vue';
import MultiselectRowAccessible from '@/common/components/MultiselectRowAccessible.vue';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import MunicipalitiesControl from "@/common/components/MunicipalitiesControl.vue";
import SingleSelectAccessible from '@/common/components/SingleSelectAccessible.vue';
import OrganisationSearchAndSelect from '@/common/components/OrganisationSearchAndSelect.vue';
import AttachmentRow from '@/common/components/AttachmentRow.vue';
import { Partner } from '@/common/types/Partner';
import { Option } from '@/common/types/Option';
import { PartnerType } from '@/common/types/PartnerType';
import { CooperationType } from '../types/CooperationType';
import MasterDataConsumer from "@/common/mixins/MasterDataConsumer";
import { optionsFor } from "@/common/utils/enumUtilities";
import { Savable } from "../mixins/Savable";
import { HealthCareDistrict } from "../types/HealthCareDistrict";
import _ from 'lodash';
var PartnerControl = /** @class */ (function (_super) {
    __extends(PartnerControl, _super);
    function PartnerControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.descriptionKey = "";
        _this._selectedOrganisation = null;
        return _this;
    }
    Object.defineProperty(PartnerControl.prototype, "selectedOrganisation", {
        get: function () {
            if (this.partner.type == PartnerType.Organisation) {
                if (this._selectedOrganisation == null && this.partner.description)
                    return { name: this.partner.description, id: null };
                else if (this._selectedOrganisation != null && this._selectedOrganisation.name == this.partner.description)
                    return this._selectedOrganisation;
            }
            return null;
        },
        set: function (value) {
            this._selectedOrganisation = value;
            this.partner.description = value === null || value === void 0 ? void 0 : value.name;
            this.forceSave();
        },
        enumerable: false,
        configurable: true
    });
    PartnerControl.prototype.onPropertyChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.partner.description = "";
                this.partner.descriptionId = null;
                this.partner.municipalities = [];
                this.partner.wellbeingServiceCounties = [];
                this.descriptionKey = Date();
                return [2 /*return*/];
            });
        });
    };
    PartnerControl.prototype.onChange = function () {
        if (this.isAttachmentRequired) {
            this.partner.attachment.isRequired = true;
        }
        else {
            this.partner.attachment.isRequired = false;
        }
    };
    Object.defineProperty(PartnerControl.prototype, "partnerTypeOptions", {
        get: function () {
            var _a;
            // reorder values so "other" is last
            var partnerTypeOrder = (_a = {},
                _a[PartnerType.Municipality] = 1,
                _a[PartnerType.Organisation] = 2,
                _a[PartnerType.Congregation] = 3,
                _a[PartnerType.HealthCareDistrict] = 4,
                _a[PartnerType.WellbeingServiceCounty] = 5,
                _a[PartnerType.Other] = 6,
                _a);
            var options = optionsFor(Option, "PartnerTypeOptions", false, function (path) { return path; }, [PartnerType.Region]);
            return options.sort(function (a, b) { return partnerTypeOrder[a.id] - partnerTypeOrder[b.id]; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartnerControl.prototype, "cooperationTypeOptions", {
        get: function () {
            var _this = this;
            var $t = function (key) { return _this.$t(key); };
            return optionsFor(Option, "CooperationTypeOptions", false, $t);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartnerControl.prototype, "PartnerType", {
        get: function () {
            return PartnerType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartnerControl.prototype, "showCooperationContent", {
        get: function () {
            if (this.partner.type && this.partner.cooperationTypes != undefined) {
                if (this.partner.cooperationTypes.length != 0) {
                    return true;
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartnerControl.prototype, "isAttachmentRequired", {
        get: function () {
            var e_1, _a;
            try {
                for (var _b = __values(this.partner.cooperationTypes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var option = _c.value;
                    switch (option.id) {
                        case CooperationType.FinancialCoopAidTransfer:
                            return true;
                        case CooperationType.FinancialCoopEmployeeResource:
                            return true;
                        case CooperationType.FinancialCoopPremisesUsage:
                            return true;
                        default:
                            break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    PartnerControl.prototype.getOptions = function (type) {
        var _this = this;
        var $t = function (key) { return _this.$t(key); };
        switch (type) {
            case PartnerType.Municipality:
                return this.municipalities;
            case PartnerType.Congregation:
                return this.congregations;
            case PartnerType.HealthCareDistrict:
                return optionsFor(Option, "HealthCareDistrictOptions", false, $t, this.healthCareDistrictBlacklist);
            case PartnerType.WellbeingServiceCounty:
                return this.wellbeingServiceCounties;
            default:
                break;
        }
    };
    PartnerControl.prototype.getTitle = function (type) {
        switch (type) {
            case PartnerType.Municipality:
                return "AidApplication.Partners.Municipality";
            case PartnerType.Organisation:
                return "AidApplication.Partners.STEAOrganisationName";
            case PartnerType.Congregation:
                return "AidApplication.Partners.CongregationName";
            case PartnerType.HealthCareDistrict:
                return "AidApplication.Partners.HealthCareDistrict";
            case PartnerType.WellbeingServiceCounty:
                return "AidApplication.Partners.WellbeingServiceCounty";
            case PartnerType.Other:
                return "AidApplication.Partners.OtherDescription";
            default:
                break;
        }
    };
    Object.defineProperty(PartnerControl.prototype, "showMunicipalitiesRow", {
        get: function () {
            return !this.hideMunicipalitiesDetail
                && this.partner.type
                && this.partner.type !== PartnerType.Municipality
                && this.partner.type !== PartnerType.WellbeingServiceCounty;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartnerControl.prototype, "healthCareDistrictBlacklist", {
        get: function () {
            var excludedDistricts = [];
            _.forIn(HealthCareDistrict, function (value, key) {
                if (isNaN(value)) {
                    if (!value.toString().includes("erva")) {
                        excludedDistricts.push(parseInt(key));
                    }
                }
            });
            return excludedDistricts;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], PartnerControl.prototype, "title", void 0);
    __decorate([
        Prop(Object),
        __metadata("design:type", typeof (_a = typeof Partner !== "undefined" && Partner) === "function" ? _a : Object)
    ], PartnerControl.prototype, "partner", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], PartnerControl.prototype, "index", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], PartnerControl.prototype, "hideMunicipalitiesDetail", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], PartnerControl.prototype, "notifyonuploadedsuccess", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], PartnerControl.prototype, "isDuplicatedFileName", void 0);
    __decorate([
        Watch("partner.type"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], PartnerControl.prototype, "onPropertyChanged", null);
    __decorate([
        Watch("partner.cooperationTypes"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PartnerControl.prototype, "onChange", null);
    PartnerControl = __decorate([
        Component({
            name: "PartnerControl",
            components: {
                HeaderControl: HeaderControl,
                MultiselectRowAccessible: MultiselectRowAccessible,
                TextAreaRow: TextAreaRow,
                SingleSelectAccessible: SingleSelectAccessible,
                OrganisationSearchAndSelect: OrganisationSearchAndSelect,
                MunicipalitiesControl: MunicipalitiesControl,
                AttachmentRow: AttachmentRow
            }
        })
    ], PartnerControl);
    return PartnerControl;
}(Mixins(MasterDataConsumer, Savable)));
export default PartnerControl;
